import { render, staticRenderFns } from "./addSundy.vue?vue&type=template&id=ca6b465c&"
import script from "./addSundy.vue?vue&type=script&lang=js&"
export * from "./addSundy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports